module.exports = __webpack_public_path__ + "img/env_icon4.6671fa92.png";